import { SET_DEPOSIT } from '../actions/depositAction';
import { reactLocalStorage } from 'reactjs-localstorage';
import Const from '../const';

const INITIAL_STATE = {
  deposit: 0,
};

const depositReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_DEPOSIT:
      reactLocalStorage.setObject(Const.appName + '#deposit', action.deposit);
      return Object.assign({}, state, {
        deposit: action.deposit,
      });
    default:
      return state;
  }
};

export default depositReducer;
